module.exports = __webpack_public_path__ + "img/9788950932855.b1ca5a10.jpg";